import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import PropTypes from "prop-types";
import { Component } from "react";
import { Result } from "@elastic/react-search-ui-views";
import { withSearch } from "..";
import { Result as ResultType } from "../types";
export var ResultContainer = /*#__PURE__*/function (_Component) {
  _inherits(ResultContainer, _Component);

  function ResultContainer() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ResultContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ResultContainer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleClickLink", function (id) {
      var _this$props = _this.props,
          clickThroughTags = _this$props.clickThroughTags,
          shouldTrackClickThrough = _this$props.shouldTrackClickThrough,
          trackClickThrough = _this$props.trackClickThrough;

      if (shouldTrackClickThrough) {
        trackClickThrough(id, clickThroughTags);
      }
    });

    return _this;
  }

  _createClass(ResultContainer, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          className = _this$props2.className,
          result = _this$props2.result,
          titleField = _this$props2.titleField,
          urlField = _this$props2.urlField,
          view = _this$props2.view,
          trackClickThrough = _this$props2.trackClickThrough,
          shouldTrackClickThrough = _this$props2.shouldTrackClickThrough,
          clickThroughTags = _this$props2.clickThroughTags,
          rest = _objectWithoutProperties(_this$props2, ["className", "result", "titleField", "urlField", "view", "trackClickThrough", "shouldTrackClickThrough", "clickThroughTags"]);

      var View = view || Result;
      return View(_objectSpread({
        className: className,
        result: result,
        key: "result-".concat(result.id.raw),
        onClickLink: function onClickLink() {
          return _this2.handleClickLink(result.id.raw);
        },
        titleField: titleField,
        urlField: urlField
      }, rest));
    }
  }]);

  return ResultContainer;
}(Component);

_defineProperty(ResultContainer, "propTypes", {
  // Props
  className: PropTypes.string,
  clickThroughTags: PropTypes.arrayOf(PropTypes.string),
  titleField: PropTypes.string,
  urlField: PropTypes.string,
  view: PropTypes.func,
  result: ResultType.isRequired,
  shouldTrackClickThrough: PropTypes.bool,
  // Actions
  trackClickThrough: PropTypes.func
});

_defineProperty(ResultContainer, "defaultProps", {
  clickThroughTags: [],
  shouldTrackClickThrough: true
});

export default withSearch(function (_ref) {
  var trackClickThrough = _ref.trackClickThrough;
  return {
    trackClickThrough: trackClickThrough
  };
})(ResultContainer);